import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Send } from "lucide-react";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export function SignRequestDialog({ affidavit, onClose, onSent }) {
  const [name, setName] = useState(affidavit.server_name || "");
  const [email, setEmail] = useState(affidavit.sign_requested_to || "");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/affidavits/${affidavit.id}/sign-request`, { email: email.trim(), name: name.trim() }); toast.success(`Signing link emailed to ${data.to}`); onSent(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed to send"); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="sign-request-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Send className="h-4 w-4" />Request signature</DialogTitle><DialogDescription>Emails the serving process server a one-tap link to read and sign this affidavit from their phone — no account needed. The link expires in 14 days.</DialogDescription></DialogHeader>
        <div className="space-y-3">
          <div><div className="sm-label mb-1">Signer's name</div><Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Process server's full name" data-testid="sign-request-name" /></div>
          <div><div className="sm-label mb-1">Email address</div><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="server@partner.com" data-testid="sign-request-email" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="sign-request-cancel">Cancel</Button>
          <Button className="sm-green" disabled={busy || !EMAIL_RE.test(email.trim())} onClick={send} data-testid="sign-request-send"><Send className="h-3.5 w-3.5 mr-1.5" />{busy ? "Sending…" : "Send signing link"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
